
export {DataTable};

import {state} from './index.js';
import {Arrow, CheckedDot, EmptyDot, HalfDot} from './glyphs.js';
import {ipx} from './utils.js';

// ---------------------------
// SORT QUEUE
// ---------------------------

function SortQueue(len) {
	// ---------------------------
	// Properties
	// ---------------------------

	// Create the queue
	this.level = [];

	// Fill queue with nulls. Hitting a null stops the recursive sorting.
	for (var r = 0; r <= len; r++) {
		this.level.push(null);
	}


	// ---------------------------
	// Methods
	// ---------------------------

	this.push = function(dtype, prop, order) {
		this.level.splice( 0, 0, { "dtype": dtype, "prop": prop, "order": order } );

		while (this.level.length > len + 1) {
			this.level.splice(len, 1);
		}
	};
}


// ---------------------------
// DATA TABLE
// ---------------------------

DataTable.HEADER_HEIGHT = 30;
DataTable.ROW_HEIGHT    = 30;
DataTable.CLEAR_RATE    = 1;
DataTable.SORT_RATE     = 1;
DataTable.FILL_RATE     = 7;
DataTable.FILL_LUMP     = 500;

function DataTable(container, h, selectable_rows, sortable, listener) {

	// ---------------------------
	// Container
	// ---------------------------

	var dt          = document.createElement('div');
	dt.className    = "data_table";
	dt.style.height = typeof h === 'string' ? h : ipx(h);
	container.appendChild(dt);


	// ---------------------------
	// Properties
	// ---------------------------

	var TableHeader = DataTableHeader(dt, DataTable.HEADER_HEIGHT, sortable, this);
	var TableRows   = document.createElement('div');

	// Adjust header to account for scrollbar in table on Windows
	if (window.navigator.platform.indexOf('Win') > -1){
		$(TableHeader.ui).css('padding-right', 16);
	}

	TableRows.style.height = ipx(h - DataTable.HEADER_HEIGHT);
	TableRows.className    = "data_table_rows";
	dt.appendChild(TableRows);

	var DataRecs    = [];
	var SortQ       = new SortQueue(10);
	var SelRow      = null;

	// ---------------------------
	// Functions
	// ---------------------------

	this.add_head        = f_add_head;
	this.load_data       = f_load_data;
	this.load_data_async = f_load_data_async;
	this.row_selected    = f_row_selected;
	this.row_dblclicked  = f_row_dblclicked;
	this.head_checked    = f_head_checked;
	this.cell_checked    = f_cell_checked;
	this.sort_column     = f_sort_column;
	this.scroll_to_ix    = f_scroll_to_ix;
	this.get_head_ix     = f_get_head_ix;
	this.get_head        = f_get_head;
	this.get_table       = f_get_table;
	this.get_sel_row     = f_get_sel_row;
	this.clear_all_rows  = f_clear_all_rows;

	this.export_rows = f_export_rows;
	this.export_detailed_rows = f_export_detailed_rows;

	// ---------------------------
	// Methods
	// ---------------------------

	function f_data_sort(a, b, lev) {

		// Get the sort level
		lev = (lev != undefined) ? lev : 0;

		// Return if the level is past the end of the sort queue
		if (lev > SortQ.level.length + 1) {
			return 1;
		} else if (SortQ.level[lev] === null) {
			return 1;
		}

		// Init the comparative values
		propA = 0;
		propB = 0;

		// Get the sort params
		var dtype = SortQ.level[lev].dtype;
		var propA = a[SortQ.level[lev].prop];
		var propB = b[SortQ.level[lev].prop];
		var order = (SortQ.level[lev].order == 'up') ? 1 : -1;

		// Normalize the values
		if (dtype == 'int') {
			propA = parseInt(propA);
			propB = parseInt(propB);

		} else if (dtype == 'date') {
			propA = (new Date( (new Date(propA)).toString().substring(0, 15) )).getTime();
			propB = (new Date( (new Date(propB)).toString().substring(0, 15) )).getTime();
		} else if (dtype == 'score') {
			if (propA && propB) {
				propA = 1000000 + (propA.us * 1000) + propA.them;
				propB = 1000000 + (propB.us * 1000) + propB.them;
			}
		}

		// Compare
		if (propA > propB) {
			return order;
		} else if (propA < propB) {
			return -order;
		} else {
			return f_data_sort(a, b, lev + 1);
		}
	}

	function f_add_head(prop, dtype, label, align, width) {
		TableHeader.add_head(prop, dtype, label, align, width);
	}

	function f_load_data(data_recs, nosort, editable) {

		// Init the data recs
		DataRecs = data_recs;

		// Clear the table
		while (TableRows.children.length > 0) {
			TableRows.removeChild(TableRows.firstChild);
		}

		if ((nosort == undefined) || (nosort == false)) {
			// Assume the first column is the sort column
			SortQ.push(TableHeader[0].dtype, TableHeader[0].prop, TableHeader[0].sort_order);

			// Sort the table from right to left
			for (let j = TableHeader.length - 1; j >= 0; j--) {
				SortQ.push(TableHeader[j].dtype, TableHeader[j].prop, TableHeader[j].sort_order);
			}

			// Sort the data recs
			DataRecs.sort(f_data_sort);
		}

		// Fill the rows
		for (let i = 0; i < DataRecs.length; i++) {
			DataRecs[i].ui_elem = DataTableRow(DataTable.ROW_HEIGHT, TableHeader, DataRecs[i], this);
			DataRecs[i].ui_elem.selectable = (selectable_rows != undefined) ? selectable_rows : true;
			DataRecs[i].ui_elem.ix = i;
			if (editable) {
				DataRecs[i].ui_elem.setAttribute("data_timestamp", DataRecs[i].date);
			}
			if (DataRecs[i].team === 'them') {
				$(DataRecs[i].ui_elem).find('.action_cell,.playernum_cell,.playername_cell').css('color', '#999');
			}

			TableRows.appendChild(DataRecs[i].ui_elem);
		}

		// Select the header
		if (sortable) {
			TableHeader[0].select();
		}

		// Select the first row
		if (DataRecs.length > 0) {
			DataRecs[0].ui_elem.onclick();
		}
	}

	function f_clear_all_rows() {
		while (TableRows.children.length > 0) {
			TableRows.removeChild(TableRows.firstChild);
		}
	}

	function f_export_rows() {
		let result = "";
		for (let i = 0; i < DataRecs.length; i++) {
			let data = DataRecs[i];
			if (data.vid) {
				// YouTube New API - Aug 2016
				// https://www.youtube.com/embed/xUys3twm6Is?start=756&end=766&autoplay=1&hl=en_US
				let yt_url = `https://www.youtube.com/embed/${data.vid}?start=${data.vstart}&end=${data.vend}&autoplay=1&hl=en_US`;

				result += yt_url + "\n";
			}
		}
		return result;
	}

	function f_export_detailed_rows() {

		let result = [];
		for (let i = 0; i < DataRecs.length; i++) {
			let data = DataRecs[i];
			if (data.vid) {

				result.push({
					date: data.date,
					playernum: data.playernum,
					playername: data.playername,
					category: data.category,
					action: data.action,
					rotation: data.rotation,
					gamenum: data.gamenum,
					opponent: data.opponent,
					score: data.score,
					created: data.created,
					vid: data.vid,
					vstart: data.vstart,
					vend: data.vend
				});
			}
		}
		return result;
	}

	function f_load_data_async(data_recs, nosort, progress) {

		// Create scope variable for this
		var mom = this;

		// Get the number of old records
		var old_recs = DataRecs.length;

		// Init the data recs
		DataRecs = data_recs;

		// Set the progress bar max and text
		if (progress) {
			progress.set_text("Searching " + DataRecs.length + " records...");
			progress.set_max(
				(DataTable.CLEAR_RATE * old_recs)
				+ (DataTable.SORT_RATE * DataRecs.length)
				+ (DataTable.FILL_RATE * DataRecs.length));
		}

		// Init the current row to operate on
		var rowix = 0;

		function clear_rows() {
			// Clear rows
			f_clear_all_rows();

			// Update progress
			if (progress) {
				progress.increment(DataTable.CLEAR_RATE * old_recs);
			}

			// Sort the rows
			window.setTimeout(sort_rows, 1);
		}

		function sort_rows() {
			if ((nosort == undefined) || (nosort == false)) {
				// Assume the first column is the sort column
				SortQ.push(TableHeader[0].dtype, TableHeader[0].prop, TableHeader[0].sort_order);

				// Sort the table from right to left
				for (var j = TableHeader.length - 1; j >= 0; j--) {
					SortQ.push(TableHeader[j].dtype, TableHeader[j].prop, TableHeader[j].sort_order);
				}

				// Sort the data recs
				DataRecs.sort(f_data_sort);
			}

			// Update progress
			if (progress) {
				progress.increment(DataTable.SORT_RATE * DataRecs.length);
			}

			// Fill the first row
			window.setTimeout(fill_rows, 1);
		}

		function fill_rows() {
			if (rowix >= DataRecs.length) {
				// Make initial selections
				window.setTimeout(make_selections, 1);
				return;
			}

			// Fill the row
			for (let i = rowix; i < Math.min(rowix + DataTable.FILL_LUMP, DataRecs.length); i++) {
				DataRecs[i].ui_elem = DataTableRow(DataTable.ROW_HEIGHT, TableHeader, DataRecs[i], mom);
				DataRecs[i].ui_elem.selectable = (selectable_rows != undefined) ? selectable_rows : true;
				DataRecs[i].ui_elem.ix = i;
				TableRows.appendChild(DataRecs[i].ui_elem);
			}

			// Increment the current row to operate on
			rowix += DataTable.FILL_LUMP;

			// Update progress
			if (progress) {
				progress.increment(DataTable.FILL_LUMP * DataTable.FILL_RATE);
			}

			// Fill the next row
			window.setTimeout(fill_rows, 1);
		}

		function make_selections() {
			// Select the header
			if (sortable) {
				TableHeader[0].select();
			}

			// Select the first row
			if (DataRecs.length > 0) {
				DataRecs[0].ui_elem.onclick();
			}
		}

		// Start the loading process
		window.setTimeout(clear_rows, 1);
	}

	function f_sort_column(prop, dtype, sort_order) {

		SortQ.push(dtype, prop, sort_order);
		DataRecs.sort(f_data_sort);

		// Remove the elements in the rows
		while (TableRows.children.length > 0) {
			TableRows.removeChild(TableRows.firstChild);
		}

		// Add the newly sorted elements
		for (var i = 0; i < DataRecs.length; i++) {
			TableRows.appendChild(DataRecs[i].ui_elem);
		}

		// Scroll to the top
		TableRows.scrollTop = 0;

		// Deselect the selected item
		if (SelRow) {
			SelRow.deselect();
			SelRow = null;
		}
	}

	function f_scroll_to_ix(ix) {
		TableRows.scrollTop = ix * DataTable.ROW_HEIGHT;
	}

	function f_get_head_ix(prop) {
		return TableHeader.get_head_ix(prop);
	}

	function f_get_head(prop) {
		return TableHeader.get_head(prop);
	}

	function f_get_table() {
		return dt;
	}

	function f_get_sel_row() {
		return SelRow;
	}


	// ---------------------------
	// Event Handlers
	// ---------------------------

	function f_row_selected(r) {

		// Clear unselected recs
		for (var i = 0; i < TableRows.children.length; i++) {
			if (r != TableRows.children[i]) {
				TableRows.children[i].select(false);
			}
		}

		// Set the selected rec
		SelRow = r;

		// Notify the listener
		if (listener != undefined) {
			if (listener.row_selected != undefined) {
				listener.row_selected(r);
			}
		}
	}

	function f_row_dblclicked(r) {

		// Notify the listener
		if (listener != undefined) {
			if (listener.row_dblclicked != undefined) {
				listener.row_dblclicked(r);
			}
		}
	}

	function f_head_checked(prop, checked) {

		if (listener != undefined) {
			if (listener.head_checked != undefined) {
				listener.head_checked(prop, checked);
			}
		}
	}

	function f_cell_checked(datarec, prop) {

		if (listener != undefined) {
			if (listener.cell_checked != undefined) {
				listener.cell_checked(datarec, prop);
			}
		}
	}

}


// ---------------------------
// DATA TABLE HEAD
// ---------------------------

function DataTableHead(prop, dtype, label, align, w, h, sortable, listener) {

	// ---------------------------
	// Properties
	// ---------------------------

	var d                    = document.createElement('div');
	d.className              = "data_table_head";
	d.style.textAlign        = align;
	d.style.height           = ipx(h);
	$(d).addClass('cell-flex'+w);  // previously used w as pixel width but now represents flex-grow (1=smallest, 4=biggest)
	$(d).text(label);

	// columns to be hidden on mobile screen sizes
	if (label === "Category"){
		$(d).addClass('hide-mobile');
	}

	d.arrow                        = {};
	d.arrow.up                     = Arrow(7, "#ffcc00", "N");
	d.arrow.down                   = Arrow(7, "#ffcc00", "S");

	d.arrow.up.style.marginTop     = ipx(11);
	d.arrow.up.style.marginRight   = ipx(5);
	d.arrow.up.style.cssFloat      = "right";
	d.arrow.down.style.marginTop   = ipx(11);
	d.arrow.down.style.marginRight = ipx(5);
	d.arrow.down.style.cssFloat    = "right";

	d.appendChild(d.arrow.up);
	d.appendChild(d.arrow.down);

	d.sortable   = (sortable != undefined) ? sortable : true;
	d.sort_order = "up";
	d.selected   = false;
	d.prop       = prop;
	d.dtype      = dtype;
	d.align      = align;

	d.colors           = {};
	d.colors.bg        = {};
	d.colors.bg.up     = "#777777";
	d.colors.bg.over   = "#999999";
	d.colors.bg.down   = "#666666";
	d.colors.bg.sel    = "#555555";
	d.colors.text      = {};
	d.colors.text.up   = "#dddddd";
	d.colors.text.over = "#ffffff";
	d.colors.text.down = "#cccccc";
	d.colors.text.sel  = "#eeeeee";

	if (d.prop === "playernum"){
		d.style.display = "none";
		d.style.width = 0;
	}


	// ---------------------------
	// Functions
	// ---------------------------

	d.select      = f_select;
	d.deselect    = f_deselect;
	d.onmouseover = f_onmouseover;
	d.onmousedown = f_onmousedown;
	d.onmouseout  = f_onmouseout;
	d.onclick     = f_onclick;


	// ---------------------------
	// Methods
	// ---------------------------

	function f_select(tf) {
		d.selected = (tf != undefined) ? tf : true;

		d.style.background = (d.selected == true) ? d.colors.bg.sel   : d.colors.bg.up;
		//d.text.style.color = (d.selected == true) ? d.colors.text.sel : d.colors.text.up;

		d.arrow.up.style.visibility   = ((d.selected == true) && (d.sort_order == 'up'))   ? "visible" : "hidden";
		d.arrow.up.style.display      = ((d.selected == true) && (d.sort_order == 'up'))   ? "block"   : "none";
		d.arrow.down.style.visibility = ((d.selected == true) && (d.sort_order == 'down')) ? "visible" : "hidden";
		d.arrow.down.style.display    = ((d.selected == true) && (d.sort_order == 'down')) ? "block"   : "none";
	}

	function f_deselect() {
		f_select(false);
	}

	function f_onmouseover() {
		d.style.background = d.colors.bg.over;
		//d.text.style.color = d.colors.text.over;
	}

	function f_onmousedown() {
		d.style.background = d.colors.bg.down;
		//d.text.style.color = d.colors.text.down;
	}

	function f_onmouseout() {
		d.style.background = (d.selected == true) ? d.colors.bg.sel   : d.colors.bg.up;
		//d.text.style.color = (d.selected == true) ? d.colors.text.sel : d.colors.text.up;
	}

	function f_onclick() {
		if (! d.sortable) {
			return;
		}

		if (d.selected) {
			d.sort_order = (d.sort_order == 'up') ? 'down' : 'up';
		}

		f_select();

		if (listener != undefined) {
			listener.head_selected(d);
		}
	}


	// ---------------------------
	// Return
	// ---------------------------

	f_deselect();
	return d;
}


// ---------------------------
// DATA TABLE CHECKBOX HEAD
// ---------------------------

function DataTableCheckboxHead(prop, align, w, h, listener) {

	// ---------------------------
	// Properties
	// ---------------------------

	var d              = document.createElement('div');
	d.className        = "data_table_head";
	//d.style.width      = ipx(w);
	d.style.height     = ipx(h);
	d.style.background = "#777777";
	d.style.textAlign  = align;

	d.cb               = document.createElement('input');
	d.cb.type          = "checkbox";
	d.cb.checked       = false;
	d.cb.padding       = ipx(0);
	d.cb.style.margin  = "8px 0px 0px";
	d.cb.onchange      = f_checkbox_changed;
	d.appendChild(d.cb);

	d.prop       = prop;
	d.dtype      = "checkbox";
	d.align      = align;
	d.select     = f_select;
	d.check      = f_check;


	// ---------------------------
	// Methods
	// ---------------------------

	function f_select() {
		d.cb.checked = true;
	}

	function f_check(tf) {
		d.cb.checked = tf;
	}

	function f_checkbox_changed() {
		if (listener != undefined) {
			if (listener.head_checked != undefined) {
				listener.head_checked(d.prop, d.cb.checked);
			}
		}
	}


	// ---------------------------
	// Return
	// ---------------------------

	return d;
}


// ---------------------------
// DATA TABLE HEADER
// ---------------------------

function DataTableHeader(container, height, sortable, listener) {

	// ---------------------------
	// Properties
	// ---------------------------

	var header             = [];
	header.sortable        = (sortable != undefined) ? sortable : true;
	header.ui              = document.createElement('div');
	header.ui.className    = "data_table_header";
	header.ui.style.height = ipx(height);
	//header.ui.style.width  = ipx(16); // Set to scrollbar width

	container.appendChild(header.ui);

	// ---------------------------
	// Functions
	// ---------------------------

	header.add_head      = f_add_head;
	header.head_selected = f_head_selected;
	header.head_checked  = f_head_checked;
	header.get_head_ix   = f_get_head_ix;
	header.get_head      = f_get_head;


	// ---------------------------
	// Methods
	// ---------------------------

	function f_add_head(prop, dtype, label, align, width) {

		// Add the cell
		var head;
		if (dtype == "checkbox") {
			head = DataTableCheckboxHead(prop, align, width, height, this);
		} else {
			head = DataTableHead(prop, dtype, label, align, width, height, header.sortable, this);
		}
		header.push(head);
		header.ui.appendChild(head);
	}

	function f_head_selected(h) {

		for (var i = 0; i < header.length; i++) {
			header[i].select(header[i] == h);
		}

		if (listener != undefined) {
			listener.sort_column(h.prop, h.dtype, h.sort_order);
		}
	}

	function f_head_checked(prop, checked) {

		if (listener != undefined) {
			if (listener.head_checked != undefined) {
				listener.head_checked(prop, checked);
			}
		}
	}

	function f_get_head_ix(prop) {
		for (var i = 0; i < header.length; i++) {
			if (header[i].prop == prop) {
				return i;
			}
		}

		return null;
	}

	function f_get_head(prop) {
		var head_ix = f_get_head_ix(prop);
		return (head_ix !== null) ? header[head_ix] : null;
	}



	// ---------------------------
	// Return
	// ---------------------------

	return header;
}


// ---------------------------
// DATA TABLE ROW
// ---------------------------

function DataTableRow(h, table_header, dataobj, listener) {

	// ---------------------------
	// Containers
	// ---------------------------

	var row          = document.createElement('div');
	row.className    = "data_table_row";
	row.style.height = ipx(h);

	// ---------------------------
	// Properties
	// ---------------------------

	row.dataobj       = dataobj;
	row.selected      = false;
	row.bgcolors      = {};
	row.bgcolors.up   = "#eeeeee";
	row.bgcolors.over = "#ffffff";
	row.bgcolors.down = "#ff8800";
	row.bgcolors.sel  = "#ff9900";
	row.cells         = [];
	row.selectable    = true;
	if (dataobj["action_cat"] === "earned" ||
		dataobj["category"] === "Earned"){
		row.bgcolors.up   = "#d8e3d8";

	} else if (dataobj["action_cat"] === "errors" ||
		dataobj["category"] === "Errors"){
		row.bgcolors.up   = "#eeddcc";

	} else if (dataobj["action_cat"] === "faults" ||
		dataobj["category"] === "Faults"){
		row.bgcolors.up   = "#eed3d3";
	}

	function checkboxOnChange() {
		if (listener != undefined) {
			if (listener.cell_checked != undefined) {
				listener.cell_checked(dataobj, this.prop);
			}
		}
	}

	for (let i = 0; i < table_header.length; i++) {
		// Create the cell
		let cell                = document.createElement('div');
		cell.className          = "data_table_cell";
		cell.style.height       = ipx(h);
		cell.style.lineHeight   = ipx(h);
		cell.style.textAlign    = table_header[i].align;
		if ( $(table_header[i]).hasClass('cell-flex0') ){ $(cell).addClass('cell-flex0'); }
		if ( $(table_header[i]).hasClass('cell-flex1') ){ $(cell).addClass('cell-flex1'); }
		if ( $(table_header[i]).hasClass('cell-flex2') ){ $(cell).addClass('cell-flex2'); }
		if ( $(table_header[i]).hasClass('cell-flex3') ){ $(cell).addClass('cell-flex3'); }
		if ( $(table_header[i]).hasClass('cell-flex4') ){ $(cell).addClass('cell-flex4'); }
		if ( $(table_header[i]).hasClass('hide-mobile') ){ $(cell).addClass('hide-mobile'); }

		let v = dataobj[table_header[i].prop];

		if (table_header[i].dtype == "date") {
			let shortDate = document.createElement('span');
			shortDate.className = "short-date";
			shortDate.innerHTML = (new Date(v)).toLocaleDateString(undefined, { year:'2-digit', month:'numeric', day:'numeric' });
			let longDate = document.createElement('span');
			longDate.className = "long-date";
			longDate.innerHTML = (new Date(v)).toLocaleDateString(undefined, { weekday:'short', year:'numeric', month:'numeric', day:'numeric' }).replace(',', '');
			cell.appendChild(shortDate);
			cell.appendChild(longDate);

		} else if (table_header[i].dtype == "video") {
			cell.appendChild( (v == 2) ? CheckedDot("#666666", "#eeeeee") : ((v == 1) ? HalfDot("#666666", "#eeeeee") : EmptyDot("#666666", "#eeeeee")) );

		} else if (table_header[i].dtype == "assist") {
			if (dataobj.team !== 'us' || dataobj.action_code !== 'spike' && dataobj.action_code !== 'spk' && dataobj.action_code !== 'tip' && dataobj.action_code !== 'dump' && dataobj.action_code !== 'blck' && dataobj.action_code !== 'dbh'){
				$(cell).addClass('noassist');
			}
			if (v){
				let assistContainer = document.createElement("div");
				assistContainer.className = "assistnum";
				assistContainer.innerHTML = v;
				cell.appendChild(assistContainer);
				$(cell).attr('title', v + "-" + dataobj.assistname);
			}

		} else if (table_header[i].dtype == "score") {
			cell.innerHTML = (v !== null) ? v.us + "-" + v.them : "-";
			if (dataobj["action_cat"] === "in_rally"){
				$(cell).css('color', '#999');
			}

		} else if (table_header[i].dtype == "checkbox") {
			let cb                = document.createElement('input');
			cb.type               = "checkbox";
			cb.checked            = (v == true) ? true : false;
			cb.padding            = ipx(0);
			cb.style.margin       = "8px 0px 0px";
			cb.prop               = table_header[i].prop;

			cb.onchange = checkboxOnChange;

			cell.appendChild(cb);

			dataobj[table_header[i].prop] = cb;

		} else if (table_header[i].dtype == "button") {
			cell.appendChild(v);

		} else if (table_header[i].dtype == "glyph") {
			cell.appendChild(v);

		} else if (table_header[i].dtype == "del") {
			if (dataobj["action_cat"] === "in_rally" || (!dataobj["action_cat"]) || state.touch){
				$(cell).text("X").addClass("can_delete");
			}

		} else if (table_header[i].dtype == "key") {
			cell.appendChild(v);

		} else {
			cell.innerHTML = v;
		}

		$(cell).addClass(table_header[i].prop + '_cell');
		if (table_header[i].prop === "playernum"){
			cell.style.display = "none";
			//cell.style.width = 0;
			cell.style.paddingLeft = 0;
			cell.style.paddingRight = 0;
		}
		if (table_header[i].prop === "action" && dataobj.action_code === "startvideo"){
			$(cell).addClass("noedit");
		}

		row.appendChild(cell);
		row.cells.push(cell);
	}


	// ---------------------------
	// Functions
	// ---------------------------

	row.select       = f_select;
	row.deselect     = f_deselect;
	row.update_cell  = f_update_cell;
	row.get_cell     = f_get_cell;

	row.onmouseover = f_onmouseover;
	row.onmousedown = f_onmousedown;
	row.onmouseout  = f_onmouseout;
	row.onclick     = f_onclick;
	row.ondblclick  = f_ondblclick;


	// ---------------------------
	// Methods
	// ---------------------------

	function f_select(tf) {
		row.selected         = (tf != undefined) ? tf : true;
		row.style.background = (row.selected == true) ? row.bgcolors.sel : row.bgcolors.up;
	}

	function f_deselect() {
		f_select(false);
	}

	function f_update_cell(ix, value) {
		row.cells[ix].innerHTML = value;
	}

	function f_get_cell(ix) {
		return row.cells[ix];
	}

	// ---------------------------
	// Events
	// ---------------------------

	function f_onmouseover() {
		if (! row.selected) {
			row.style.background = row.bgcolors.over;
		}
	}

	function f_onmousedown() {
		if (! row.selectable) {
			return;
		}
		row.style.background = row.bgcolors.down;
	}

	function f_onmouseout() {
		f_select(row.selected);
	}

	function f_onclick() {

		if (! row.selectable) {
			return;
		}

		f_select(true);

		if (listener != undefined) {
			if (listener.row_selected != undefined) {
				listener.row_selected(row);
			}
		}
	}

	function f_ondblclick() {

		if (! row.selectable) {
			return;
		}

		f_select(true);

		if (listener != undefined) {
			if (listener.row_selected != undefined) {
				listener.row_selected(row);
			}
		}

		if (listener != undefined) {
			if (listener.row_dblclicked != undefined) {
				listener.row_dblclicked(row);
			}
		}
	}

	// ---------------------------
	// Return
	// ---------------------------

	return row;
}
